"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.182 3.018c1.553.112 3.135.772 4.62 2.078a.7.7 0 0 1-.926 1.05c-1.283-1.128-2.582-1.644-3.796-1.732-1.216-.088-2.394.25-3.436.91-1.24.787-2.27 2.022-2.905 3.489h4.605a.7.7 0 0 1 0 1.4h-5.07a8.2 8.2 0 0 0-.224 1.902q0 .668.111 1.309h5.183a.7.7 0 1 1 0 1.4H8.537c.602 1.626 1.718 2.996 3.1 3.846 2.064 1.271 4.74 1.394 7.267-.61a.7.7 0 0 1 .87 1.097c-3.007 2.385-6.326 2.272-8.872.705-1.788-1.1-3.186-2.91-3.843-5.038H4.661a.7.7 0 1 1 0-1.4h2.083a9 9 0 0 1-.094-1.309c0-.646.066-1.284.19-1.902H4.66a.7.7 0 0 1 0-1.4h2.574c.709-1.958 2.017-3.629 3.66-4.671 1.265-.802 2.738-1.237 4.288-1.124",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyEuroIcon24.js.map